"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectionDetails = exports.collections = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var collections_1 = require("../fragments/collections");

var pageInfo_1 = require("../fragments/pageInfo");

exports.collections = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  query CollectionList(\n    $first: Int!\n    $after: String\n    $sortBy: CollectionSortingInput\n    $filter: CollectionFilterInput\n    $channel: String\n  ) {\n    collections(\n      first: $first\n      after: $after\n      sortBy: $sortBy\n      filter: $filter\n      channel: $channel\n    ) {\n      edges {\n        node {\n          ...BaseCollection\n        }\n      }\n      pageInfo {\n        ...PageInfo\n      }\n      totalCount\n    }\n  }\n"])), collections_1.baseCollectionFragment, pageInfo_1.pageInfo);
exports.collectionDetails = graphql_tag_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  query CollectionDetails($id: ID, $slug: String, $channel: String) {\n    collection(id: $id, slug: $slug, channel: $channel) {\n      ...CollectionDetails\n    }\n  }\n"])), collections_1.collectionFragment);